import React from 'react'
import { NavLink, NavLinkProps } from 'react-router-dom'
import { DepartmentNavigationLinkFragment } from '#src/generated/graphql'
import { serializeSearchQuery } from '#src/services/search'
import { generateCreateUrl } from '#src/services/path'
import { keyBy, Omit } from 'lodash'
import ExpertsIcon from './experts.svg'
import styles from './styles.css'

export interface DepartmentNavigationLinkProps extends Omit<NavLinkProps, 'to'> {
  link: DepartmentNavigationLinkFragment
}

const DepartmentNavigationLink: React.SFC<DepartmentNavigationLinkProps> = ({ link, ...rest }) => {
  switch (link.__typename) {
    case 'DepartmentNavigationCategoryLink':
      const categoryLocation = serializeSearchQuery({
        categorySlug: link.category.slug!
      })

      return (
        <NavLink
          to={{
            pathname: categoryLocation.pathname,
            search: categoryLocation.searchParams.toString()
          }}
          {...rest}
        />
      )

    case 'DepartmentNavigationSearchLink':
      const { pathname, searchParams } = serializeSearchQuery({
        categorySlug: link.category.slug!,
        selections: keyBy(link.facets, 'name')
      })
      const search = searchParams.toString()

      return (
        <NavLink
          to={{ pathname, search }}
          isActive={(_match, location) => {
            return pathname === location.pathname && search === location.search.replace(/^\?/, '')
          }}
          {...rest}
        />
      )

    case 'DepartmentNavigationCreatePathLink':
      const createPathUrl = generateCreateUrl(link.pathSlug)
      return <NavLink to={createPathUrl} {...rest} />

    case 'DepartmentNavigationExpertCommunityLink':
      return (
        <NavLink to={`/reviews/${link.departmentSlug}`} {...rest}>
          <ExpertsIcon className={styles.navLinkIcon} />
          Reviews
        </NavLink>
      )

    default:
      return null
  }
}

export default DepartmentNavigationLink
